export default __webpack_public_path__ + "static/media/head-right-side.19a5f7ba.png";